import { render, staticRenderFns } from "./addPrice.vue?vue&type=template&id=67cfca1e&"
import script from "./addPrice.vue?vue&type=script&lang=js&"
export * from "./addPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67cfca1e')) {
      api.createRecord('67cfca1e', component.options)
    } else {
      api.reload('67cfca1e', component.options)
    }
    module.hot.accept("./addPrice.vue?vue&type=template&id=67cfca1e&", function () {
      api.rerender('67cfca1e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/performancecenter/theaterManage/addPrice.vue"
export default component.exports